import { IconBook, IconStar } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { config } from '@/config/config';
import { env } from '@/env';
import { useIsEligibleForReviewPrizepool, useReviewPrizepoolStore } from '@/modules/review-prizepool';
import { Link } from '@/modules/ui';

import appStoreSrc from './assets/appStore.png';
import chromeSrc from './assets/chrome.png';
import firefoxSrc from './assets/firefox.png';
import googlePlaySrc from './assets/googlePlay.svg';
import safariSrc from './assets/safari.png';
import * as felaRules from './SidebarLinks.rules';

const extensionLinks = [
    { browser: 'chrome', icon: chromeSrc, url: env.VITE_CHROME_EXT_URL },
    { browser: 'safari', icon: safariSrc, url: env.VITE_SAFARI_EXT_URL },
    { browser: 'firefox', icon: firefoxSrc, url: env.VITE_FIREFOX_EXT_URL },
] as const;

export const SidebarLinks = () => {
    const { css } = useFela();

    const isEligibleForReviewPrizepool = useIsEligibleForReviewPrizepool();
    const openReviewPrizepool = useReviewPrizepoolStore(state => state.openPopup);

    return (
        <div className={css(felaRules.container)}>
            <Link type='native' href={config.links.googlePlay} customStyle={felaRules.link}>
                <img src={googlePlaySrc} alt='' className={css(felaRules.icon)} />
                <FormattedMessage id='sidebar.links.googlePlay' />
            </Link>
            <Link type='native' href={config.links.appStore} customStyle={felaRules.link}>
                <img src={appStoreSrc} alt='' className={css(felaRules.icon)} />
                <FormattedMessage id='sidebar.links.appStore' />
            </Link>
            {isEligibleForReviewPrizepool ? (
                <button type='button' onClick={openReviewPrizepool} className={css(felaRules.link, felaRules.linkButton)}>
                    <IconStar size={16} className={css(felaRules.icon)} />
                    <FormattedMessage id='review-prizepool.sidebar.link' />
                </button>
            ) : null}
            {extensionLinks.map(({ browser, icon, url }) => (
                <Link key={browser} type='native' href={url} customStyle={felaRules.link}>
                    <img src={icon} alt='' className={css(felaRules.icon)} />
                    <FormattedMessage id={`sidebar.links.extension.${browser}`} />
                </Link>
            ))}
            <Link type='native' href={config.links.docs} customStyle={felaRules.link}>
                <IconBook size={16} className={css(felaRules.icon)} />
                <FormattedMessage id='sidebar.links.docs' />
            </Link>
        </div>
    );
};
